export default "__VITE_ASSET__BVJs05o9__"